import React, {useEffect} from 'react';
import AuthRoutes from '../../routes/AuthRoutes';
import './AuthContainer.scss';
import i18n from 'i18next';

const AuthContainer = () => {
  useEffect(() => {
    const supportedLanguages = ['en', 'uk', 'ru'];
    const language = supportedLanguages.includes(localStorage.getItem('langD')) ? localStorage.getItem('langD') : 'uk';

    i18n.changeLanguage(language);
  }, [i18n]);

  return (
    <main className='auth-page'>
      <AuthRoutes />
    </main>
  );
};

export default AuthContainer;
